import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import Version from "../../../Version/Version";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';

class NewVersion extends Component {

  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.move = this.move.bind(this);
  }

  // close window
  public close(): any {
    this.props.dispatch({
      type: Constants.NEW_VERSION_IGNORE
    });

    Version.listen(true);
  }

  // update version
  public move(): any {
    window.location.reload();
  }

  public render(): any {
    if (this.props.available === false) {
      return null;
    }

    return (
      <div className="card card-sticky">
        <span
          className="close"
          onClick={this.close}
        >
          X
        </span>
        <Card>
          <CardHeader
            title={this.trans("title-heads-up")}
            subheader={this.trans("title-new-version-notice")}
          />
          <CardActions style={{display: "flex", justifyContent: "flex-end"}}>
            <Button
              color="primary"
              onClick={this.close}
            >
              {this.trans("label-no")}
            </Button>
            <Button
              variant="contained" 
              color="primary"
              onClick={this.move}
            >
              {this.trans("label-yes")}
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

export { NewVersion };
